import { render, staticRenderFns } from "./MobileContactUs.vue?vue&type=template&id=35348b04&scoped=true&"
import script from "./MobileContactUs.vue?vue&type=script&lang=ts&"
export * from "./MobileContactUs.vue?vue&type=script&lang=ts&"
import style0 from "./MobileContactUs.vue?vue&type=style&index=0&id=35348b04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35348b04",
  null
  
)

export default component.exports